import { Component, OnInit, Input } from '@angular/core';
import { EmbryoService } from 'src/app/Services/Embryo.service';

@Component({
  selector: 'embryo-ProductCategoryCard',
  templateUrl: './ProductCategoryCard.component.html',
  styleUrls: ['./ProductCategoryCard.component.scss'],
})
export class ProductCategoryCardComponent implements OnInit {
  @Input() productCategory: any;

  @Input() totalProducts: any;
  lang: any;

  constructor(public embryoService: EmbryoService) {
    this.embryoService.emitLang.subscribe((lang: any) => {
      this.lang = lang;
    });
  }

  ngOnInit() {}
}
